import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GroupMaintenanceComponent } from './group-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: GroupMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupMaintenanceRoutingModule { }
